import { useEffect, useState, forwardRef } from 'react';
import { cx } from '@emotion/css';
import Link from 'next/link';
import styles from '../navigation.module.scss';
import { motion } from 'framer-motion';
import { stihlMenuItemAnimate } from '../helpers/animations';
import { useRouter } from 'next/router';
import { isInternalLink, getRelativeUrl } from '../helpers/utils';

interface StihlIdMenuItemProps {
  item: any;
  onClick: () => void;
  role?: string;
}

export const StihlIdMenuItem = forwardRef<HTMLAnchorElement, StihlIdMenuItemProps>(({ item, onClick, role }, ref) => {
  const router = useRouter();
  const [isActiveRoute, setIsActiveRoute] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      const itemPathname = getRelativeUrl(item.url);
      setIsActiveRoute(router.asPath.toLowerCase() === itemPathname);
    }, 300);
  }, [item.url, router.asPath]);

  return (
    <motion.li variants={stihlMenuItemAnimate} className={cx('first:pt-4 last:pb-4')} role="none">
      <Link
        locale={false}
        href={isInternalLink(item.url) ? getRelativeUrl(item.url) : item.url}
        aria-current={isActiveRoute}
        target={item.target || '_self'}
        className={cx(
          'block px-4 py-2 stihl-text-body-default-reg',
          styles.stihlIdMenuItem,
          isActiveRoute && styles.stihlIdMenuItemActive,
          'focus-visible:outline-offset-[-3px] focus-visible:outline-[#252525] focus-visible:outline-[2px] focus-visible:outline'
        )}
        rel={item.target === '_blank' ? 'noopener noreferrer' : undefined}
        onClick={onClick}
        ref={ref}
        role={role}
      >
        <span>{item.name}</span>
      </Link>
    </motion.li>
  );
});
